import React from 'react';
import { Route } from 'react-router-dom';
import NotFound from '../Components/Pages/NotFound';

export const hostname = window.location.hostname;

export const isDomainAllowed = (allowedDomains) => {
  if (!allowedDomains || allowedDomains.length === 0) return false;
  if (allowedDomains.includes('*')) return true;
  return allowedDomains.some(domain => hostname.includes(domain));
};

export const renderRoute = ({ path, component: Comp, allowedDomains }) => (
  <Route
    key={path}
    exact
    path={path}
    component={isDomainAllowed(allowedDomains) ? Comp : NotFound}
  />
);
